// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { apiRequest } from 'utils/api';

export default function Footer() {
  const { t } = useTranslation();
  const appVersion = import.meta.env.VITE_APP_VERSION || 'dev';
  const buildNumber = import.meta.env.VITE_BUILD_NUMBER || 'local';
  const [backendVersion, setBackendVersion] = useState('loading');
  const [backendBuildNumber, setBackendBuildNumber] = useState('loading');

  useEffect(() => {
    let isCancelled = false;

    const loadBackendBuildInfo = async () => {
      try {
        const response = await apiRequest('/api/health', { auth: false });
        if (!response.ok) {
          return;
        }

        const data = await response.json();

        if (!isCancelled) {
          setBackendVersion(data?.version || 'unknown');
          setBackendBuildNumber(data?.buildNumber || 'unknown');
        }
      } catch {
        if (!isCancelled) {
          setBackendVersion('unavailable');
          setBackendBuildNumber('unavailable');
        }
      }
    };

    loadBackendBuildInfo();

    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">&copy; {t('footer.rightsReserved')} EventList</Typography>
      <Stack sx={{ textAlign: { xs: 'center', sm: 'right' } }}>
        <Typography variant="caption" color="text.secondary">
          Frontend v{appVersion} build {buildNumber}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Backend v{backendVersion} build {backendBuildNumber}
        </Typography>
      </Stack>
    </Stack>
  );
}
